import { normalize } from "normalizr";
import endpoints from "api/endpoints";
import Immutable from "immutable";
import { commission } from "schemas";

export default (
  { resultKey = "commission" } = { resultKey: "commission" }
) => ({
  url: endpoints.getCommissionUrl(),
  transform: (response) =>
    normalize(response.data, commission.arrayOfCommissionSchemas).entities,
  transformResult: (response) => ({
    [resultKey]: normalize(response.data, commission.arrayOfCommissionSchemas)
      .result,
  }),
  queryKey: endpoints.getCommissionUrl(),
  meta: {
    authToken: true,
  },
  force: true,
  options: {
    headers: {
      Accept: "application/json",
    },
  },
  update: {
    commission: (prevCommission = Immutable.Map(), result) =>
      prevCommission.mergeDeep(result),
  },
  updateResult: {
    [resultKey]: (prevResult, result) => result,
  },
});
